import React, { useState } from "react"

import dayjs from "dayjs";

import {
    productImageTypes as _productImageTypes,
    paymentTypes as _paymentTypes,
    calculateCbmByDimension as _calculateCbmByDimension,
    validationSchema as _validationSchema,
    initialValues as _initialValues,
    initialProductValues as _initialProductValues,
    validationProductSchema as _validationProductSchema,
    initialItemValues as _initialItemValues,
    validateItemSchema as _validateItemSchema,
    customInjectionProps as _customInjectionProps,
    customInjectionFields as _customInjectionFields,
    productLoadStatusTypes as _productLoadStatusTypes
} from "../../schema/items/productSchema";

import {
    validationSchema as _validationIdentitySchema,
    initialValues as _initialIdentityValues
} from "../../schema/items/productIdentitySchema"

import {
    initialValues as _initialFileValues
} from "../../../../schema/files/fileSchema"

import { useItems, itemTypes, targetTypes as itemTargetTypes, configuration } from "../../../../hooks/api/useItems"

import { useProductItem, defaultUom, itemInjectionProps } from "./useProductItem";

import {
    createProductInjectionFieldsPayload,
    createProductItemInjectionFieldsPayload
} from "../../utils/injectionFields"

import {
    useSchedulers,
    schedulerConfigs,
    schedulerTypes,
    targetTypes as schedulerTargetTypes,
    schedulerModules,
    schedulerRefs,
    schedulerTargets
} from "../../../../hooks/api/useSchedulers"

import {
    useInjectionFields,
    getUpdateFieldValuesPayload,
    scopeTypes as injectionFieldScopeTypes,
} from "../../../../hooks/api/useInjectionFields"

import {
    getUniqueProductBarcode as _getUniqueProductBarcode,
    getUniqueProductCodeShort as _getUniqueProductCodeShort,
    getUniqueProductCodeLong as _getUniqueProductCodeLong
} from "../../utils/barcode"

import { getInjectionDataType } from "../../utils/injectionSelection";

export const productImageTypes = _productImageTypes
export const productLoadStatusTypes = _productLoadStatusTypes
export const productInjectionProps = _customInjectionProps
export const productInjectionFields = _customInjectionFields
export const calculateCbmByDimension = _calculateCbmByDimension
export const paymentTypes = _paymentTypes
export const getUniqueProductBarcode = _getUniqueProductBarcode
export const getUniqueProductCodeShort = _getUniqueProductCodeShort
export const getUniqueProductCodeLong = _getUniqueProductCodeLong

export const initialValues = _initialValues
export const validationSchema = _validationSchema
export const initialProductValues = _initialProductValues
export const validationProductSchema = _validationProductSchema
export const initialItemValues = _initialItemValues
export const validateItemSchema = _validateItemSchema
export const initialIdentityValues = _initialIdentityValues
export const validationIdentitySchema = _validationIdentitySchema
export const initialFileValues = _initialFileValues

export function useProduct({
    jwtToken: _jwtToken,
    routeType: _routeType
}) {

    const [routeType, setRouteType] = useState(_routeType)

    const { get, list, remove, createBatch, filterOperatorTypes } = useItems({ itemType: itemTypes.product, targetType: itemTargetTypes.product });

    const { addProductItemBatch, addProductItemPropsBatch } = useProductItem({ routeType })

    const { updateFieldValues } = useInjectionFields({
        scopeType: injectionFieldScopeTypes.item.id
    });

    const {
        create: createSchedulerRequest,
        list: listSchedulerRequest
    } = useSchedulers({ schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })

    // private
    const fetchProduct = async ({ productId }) => {

        // setSystemLoading(true)

        try {

            let dataTypesArray = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

            const data = await getProduct({ id: productId, dataTypesArray })

            // console.log('product>>>', JSON.stringify(data))

            // setSystemLoading(false)

            return data

        } catch (error) {
            // promptMessage(false, `Action Failed (${error?.message})`)

            return {}
        }

        // setSystemLoading(false)

        // return false

    }

    const checkProductIsLoadedContainer = async ({ productId }) => {

        // check this item is loaded
        let currentProduct = await getProduct({ id: productId })

        let currentProductLoadContainerStatus = currentProduct?.product[productInjectionFields.loadStatus.retrieveKey]
        let currentProductLoadContainerId = currentProduct?.product[productInjectionFields.loadContainerId.retrieveKey]

        // console.log('currentProductLoadContainerStatus', currentProductLoadContainerStatus)
        // console.log('currentProductLoadContainerId', currentProductLoadContainerId)

        return {
            loadContainerStatus: currentProductLoadContainerStatus,
            loadContainerId: currentProductLoadContainerId
        }

    }

    // list products
    const listProducts = async ({
        props,
        productIds = [],
        loadContainerIds: _loadContainerIds,
        dataTypes = [`${getInjectionDataType('product')}`]
        // dataTypes = []
    }) => {

        props.dataTypes = dataTypes
        props.configuration = configuration.enableServerClientCancellation

        let filterValues = [
        ]

        if (productIds.length > 0) {
            filterValues = [...filterValues, ...[
                {
                    name: `id`,
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(productIds),
                },
            ]]
        }

        if (_loadContainerIds !== '') {
            filterValues = [...filterValues, ...[
                {
                    name: `${productInjectionProps.loadContainerId.retrieveKey}`,
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(_loadContainerIds),
                },
            ]]
        }

        if (props?.filterValue) {
            props.filterValue = [...props.filterValue, ...filterValues]
        } else {
            props.filterValue = filterValues
        }

        const result = await list(props)

        let data = result?.data?.products ? result.data.products : []

        return {
            data,
            // count: result?.data?.nofilter_total
            count: result?.data?.total
        }

    }

    // done
    // update the product - currently only update the injection props
    const updateProduct = async ({
        productId: _productId = '',
        sourceProductRemId: _sourceProductRemId = '',
        product: _product = {
            // itemName: "",
            // model: "",
            // productCode: "",
            // description: "",
            // categoryId: 0,
            // brandId: "",
            // summary: "",
            // status: 1,
            // defaultUomId: 0,

            loadContainerDateTime: "",
            userMarking: "",
            userBranchId: "",
            userId: "",

            barcode: "",
            loadStatus: "",
            loadContainerId: "",

            registerLocationId: "",
            registerLocationDisplay: "",

            supplierName: "",
            supplierContact: "",
            courierTrackingNo: "",
            prepaidDepositAmount: "",
            prepaidTransportAmount: "",
            signUserId: "",
            signUserDisplay: "",
            remark: "",
            paymentType: "",
            purchaseNumber: "",
            supplierPurchaseNumber: "",

        },
        lastUpdateUserId: _lastUpdateUserId,
        lastUpdateUserDisplay: _lastUpdateUserDisplay,
    }) => {

        // for injection fields
        let b = createProductInjectionFieldsPayload({
            productId: _productId,
            data: {
                input: _product
            },
            mainData: {
                marking: _product.userMarking,
                userBranchId: _product.userBranchId,
                userId: _product.userId,
                // isSplit: 0,
                // splitFromRemId: 0
            },
            skipTargetInjectionFieldIds: [
                `barcode`,
                `registerLocationId`,
                `registerLocationDisplay`,
                `loadContainerId`,
                `nfcPersonName`,
                `nfcIdentityNo`,
                `nfcFileId`,
                `nfcDetails`,
                `isSplit`,
                `checkinDateTime`,
                `splitFromRemId`,
                `sourceProductRemId`,
                `lastUpdateDatetime`,
                `lastUpdateUserId`,
                `loadStatus`,
                `lastUpdateUserDisplay`,
                // added newly if not each time edit the product will clear the load container (if have)
                `loadContainerId`,
                `loadContainerDateTime`,
                `appPrintPackQty`,
                `isAppEntry`
            ],
            barcode: _product.barcode,
            loadStatus: _product.loadStatus,
            loadContainerId: _product.loadContainerId,
        })

        // console.log('dataInjectionFields', b)

        const response = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: b }), overrideScopeType: injectionFieldScopeTypes.item.id });

        // add the scheduler requests
        // console.log('schedulerConfigs?.schedulerIntegrationIds', schedulerConfigs?.schedulerIntegrationIds)

        if (
            schedulerConfigs?.schedulerIntegrationIds &&
            schedulerConfigs?.schedulerIntegrationIds.length > 0
        ) {

            let currentProduct = await fetchProduct({ productId: _productId })

            // console.log('currentProduct', currentProduct)

            let dataSchedulerRequest = {
                scheduler_request: {
                    source_id: _productId,
                    target: schedulerTargets.request.item,
                    module: schedulerModules.request.item.product,
                    request_ref: schedulerRefs.request.item.product,
                    integration_id: schedulerConfigs?.schedulerIntegrationIds[0],
                    destination_id: currentProduct[productInjectionProps.sourceProductRemId.retrieveKey],
                    action: 'update',
                    source_data: JSON.stringify(currentProduct)
                    // JSON.stringify({
                    //     ...currentProduct,
                    //     sourceProductRemId: ''
                    // })
                }
            }

            // console.log('dataSchedulerRequest', JSON.stringify(dataSchedulerRequest))

            // create scheduler request
            let b = await createSchedulerRequest({
                data: dataSchedulerRequest,
                schedulerType: schedulerTypes.schedulerRequest,
                targetType: schedulerTargetTypes.schedulerRequest
            })

        }

        let _p = {
            productId: _productId,
            lastUpdateUserId: _lastUpdateUserId,
            lastUpdateUserDisplay: _lastUpdateUserDisplay
        }

        await updateLastUpdateProduct(_p)

        return response

    }

    // done
    const addProduct = async ({
        marking: _marking = '',
        locationId: _locationId = '',
        locationDisplay: _locationDisplay = '',

        userBranchId: _userBranchId = '',
        userDisplay: _userDisplay = '',
        userId: _userId = '',

        products: _products = [{

            signUserId: "",
            signUserDisplay: "",
            supplierContact: "",
            supplierName: "",
            supplierPurchaseNumber: "",
            companyPurchaseNumber: "",
            prepaidDepositAmount: "",
            prepaidTransportAmount: "",
            paymentType: "",

            checkinDateTime: "",

            appPrintPackQty: "",
            isAppEntry: false,

            courierTrackingNo: "",
            remark: "",
            items: [{
                uomPrice: '',
                remark: '',
                weight: '',
                description: '',
                width: 0,
                height: 0,
                length: 0,
                cbm: 0,

                code: '',
                handleQty: 0,
                handleQtyPerPackage: 0,
                qty: 0,
                totalCbm: 0,
                totalValue: 0,
                totalWeight: 0,
                uomId: '',
                uomDisplay: '',

            }]
        }],

        customSchedulerIntegrationId: _customSchedulerIntegrationId = ''
    }) => {

        let allResponses = []

        let marking = _marking

        let itemValues = []

        let masterValues = []

        let valuesProducts = _products.map(i => {

            let courierTrackingNo = `${i?.courierTrackingNo}`

            let shortenCourierTrackingNo = ''

            // shorten the tracking no - to first 14 digit
            if (courierTrackingNo.length >= 14) {
                shortenCourierTrackingNo = courierTrackingNo.substring(0, 14)
            }

            let name = `${marking}_${shortenCourierTrackingNo}`
            let model = `${marking}_${shortenCourierTrackingNo}`
            let code = getUniqueProductCodeLong()
            // `${marking}_${courierTrackingNo}`

            let items = []
            let items2 = []

            i?.items.forEach(i2 => {
                items.push({
                    // product_id: "",
                    code: `${shortenCourierTrackingNo}_{product_id}_{indexno}`,
                    // uom_id: defaultUom.id,
                    uom_id: i2?.uomId,
                    // uom_display: i2.uomDisplay,
                    cost: 0,
                    uom_price: i2?.uomPrice,
                    floor_price: 0,
                    remark: i2?.remark,
                    gross_weight: 0,
                    net_weight: i2?.weight,
                    volume_weight: 0,
                    // item_description: `${marking}`,
                    item_description: `${i2?.description}`,
                    dimension_width: i2?.width,
                    dimension_height: i2?.height,
                    dimension_length: i2?.length,
                    cbm: i2?.cbm,
                    status: 1,
                    is_package: 0
                })

                items2.push({
                    ...items,
                    input: i2
                })
            })

            itemValues.push(items)

            let a = {
                item_name: name,
                model,
                product_code: code,
                description: i?.remark,
                category_id: 0,
                brand_id: 0,
                summary: "",
                status: 1,
                // signUserId: productInjectionProps.signedByUserId.submitKey
            }

            masterValues.push({
                ...a,
                input: i,
                items: items2
            })

            return a

        })

        let dataProducts = {
            product: valuesProducts
        }

        // const response = await createItemBatch({ data: dataProducts, targetType: itemTargetTypes.product });
        const response = await addProductBatch({
            data: dataProducts
        })

        // append the product id
        response.forEach((i, index) => {
            masterValues[index].product_id = i?.id
            allResponses.push({
                productId: i?.id
            })
        })

        // console.log('response >>> ', response, masterValues)

        let allItemValues = []

        response.forEach((i, index) => {

            let productId = i?.id

            let items = itemValues[index].map((i2, index2) => {

                let itemCode = i2?.code
                itemCode = itemCode.replace(/{product_id}/g, productId);
                itemCode = itemCode.replace(/{indexno}/g, index2);

                let itemDescription = i2?.item_description
                // itemCode = itemDescription.replace(/product_id/g, productId);

                // console.log('i2', i2)

                let a = {
                    ...i2,
                    product_id: productId,
                    code: itemCode,
                    item_description: i2?.item_description,
                    remark: i2?.remark
                }

                // masterValues[index].items[index2].product_id = productId
                masterValues[index].items[index2].code = itemCode
                masterValues[index].items[index2].item_description = itemDescription

                return a
            })

            allItemValues = [...allItemValues, ...items]

        })

        // console.log('allItemValues, allItemValues', allItemValues)

        // let dataProductItems = {
        //     item: allItemValues
        // }

        let dataProductItems = allItemValues.map(i => ({
            productId: i.product_id,
            code: i.code,
            uomId: i.uom_id,
            uomPrice: i.uom_price,
            remark: i.remark,
            netWeight: i.net_weight,
            itemDescription: i.item_description,
            width: i.dimension_width,
            height: i.dimension_height,
            length: i.dimension_length,
            cbm: i.cbm,
            // for injection props
            // qty: 0,
            // handleQty: 0,
            // handleQtyPerPackage: 0,
            // totalValue: 0,
            // totalCbm: 0,
            // totalWeight: 0,
        }))

        // const responseItems = await createItemBatch({ data: dataProductItems, targetType: itemTargetTypes.item });
        const responseItems = await addProductItemBatch({
            onlyCreateData: true,
            data: dataProductItems,
            // targetType: itemTargetTypes.item 
        });

        // console.log('responseItems', responseItems)

        let allItemPropValues = responseItems.map((i, index) => {

            let itemId = i?.id
            let itemCode = i?.code
            let itemCodeArray = itemCode.split("_")

            // append the itemId
            masterValues.forEach((i4, index4) => {
                i4.items.forEach((i6, index6) => {
                    if (i6?.code === itemCode) {
                        masterValues[index4].items[index6].item_id = itemId
                    }
                })

            })

            // props
            return {
                item_id: itemId,
                scanning_code_prefix: "",
                scanning_code_suffix: `-${itemCodeArray[itemCodeArray.length - 2]}-${itemCodeArray[itemCodeArray.length - 1]}`
            }

        })

        let dataProductItemProps = {
            item: allItemPropValues
        }

        // const responseItemProps = await createItemPropBatch({ data: dataProductItemProps, targetType: itemTargetTypes.item });
        const responseItemProps = await addProductItemPropsBatch({
            data: dataProductItemProps,
            // targetType: itemTargetTypes.item 
        });


        // injection fields
        let allInjectionFields = []

        masterValues.forEach(i => {

            // console.log('i >> ', i)

            let { input } = i

            let _mainData = {
                marking: _marking,
                userBranchId: _userBranchId,
                userDisplay: _userDisplay,
                userId: _userId,
            }

            let _inputData = {
                signUserId: input.signUserId,
                signUserDisplay: input.signUserDisplay,
                courierTrackingNo: input.courierTrackingNo,
                paymentType: input.paymentType,
                checkinDateTime: input.checkinDateTime,
                prepaidDepositAmount: input.prepaidDepositAmount,
                prepaidTransportAmount: input.prepaidTransportAmount,
                remark: input.remark,
                supplierContact: input.supplierContact,
                supplierName: input.supplierName,
                supplierPurchaseNumber: input.supplierPurchaseNumber,
                purchaseNumber: input.companyPurchaseNumber
            }

            if (input?.isAppEntry === true) {
                _inputData.appPrintPackQty = input?.appPrintPackQty
                _inputData.isAppEntry = 1
            } else {
                _inputData.appPrintPackQty = 0
                _inputData.isAppEntry = 0
            }

            let barcode = getUniqueProductBarcode()

            // append inj fields
            let iF = createProductInjectionFieldsPayload({
                productId: i?.product_id,
                barcode,
                locationId: _locationId,
                locationDisplay: _locationDisplay,
                data: {
                    input: _inputData
                },
                mainData: {
                    ..._mainData,
                    isSplit: 0,
                    splitFromRemId: 0
                },
                skipTargetInjectionFieldIds: [
                    "nfcPersonName",
                    "nfcIdentityNo",
                    "nfcFileId",
                    "nfcDetails",
                    "sourceProductRemId",
                    "isAssignedDO",
                    "assignedDONumber",
                    "assignedDORemId",
                    "lastUpdateDatetime",
                    "lastUpdateUserId",
                    "lastUpdateUserDisplay",
                    // "isSplit",
                    // "splitFromRemId"
                ],
                // schedulerRequests: getAppendSchedulerProps(schedulerRequestIdsProduct, [`${getInjectionDataType('product')}`])
            })

            let productInjFields = iF
            let productItemInjFields = []

            i.items.forEach(i2 => {

                let { input } = i2

                let _mainData = {
                    marking: _marking,
                    userBranchId: _userBranchId,
                    userDisplay: _userDisplay,
                    userId: _userId,
                }

                let _inputData = {
                    cbm: input.cbm,
                    qty: input.qty,
                    handleQty: input.handleQty,
                    handleQtyPerPackage: input.handleQtyPerPackage,
                    uomName: input.uomDisplay,
                    totalValue: input.totalValue,
                    totalCbm: input.totalCbm,
                    totalWeight: input.totalWeight
                }

                // append inj fields
                let iF = createProductItemInjectionFieldsPayload({
                    itemId: i2?.item_id,
                    data: {
                        input: _inputData
                    },
                    mainData: _mainData,
                    skipTargetInjectionFieldIds: [
                        "sourceItemRemId",
                    ],
                })

                productItemInjFields = [...productItemInjFields, ...iF]

            })

            allInjectionFields = [...allInjectionFields, ...productInjFields, ...productItemInjFields]

        })

        // create injection fields
        const responseProductInjectionFields = await updateFieldValues({
            data: getUpdateFieldValuesPayload({ items: allInjectionFields }),
            overrideScopeType: injectionFieldScopeTypes.item.id,
        })

        // add the scheduler requests
        // console.log('schedulerConfigs?.schedulerIntegrationIds', schedulerConfigs?.schedulerIntegrationIds)
        if (
            (schedulerConfigs?.schedulerIntegrationIds &&
                schedulerConfigs?.schedulerIntegrationIds.length > 0) ||
            _customSchedulerIntegrationId !== ''
        ) {

            let integrationId = schedulerConfigs?.schedulerIntegrationIds[0]

            if (_customSchedulerIntegrationId) {
                integrationId = _customSchedulerIntegrationId
            }

            let promises = []

            // for (const i in masterValues) {

            masterValues.forEach(async (i) => {

                let productId = i?.product_id

                let currentProduct = await getProduct({ id: productId, dataTypesArray: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`] })

                // console.log('currentProduct', currentProduct)

                let dataSchedulerRequest = {
                    scheduler_request: {
                        source_id: productId,
                        target: schedulerTargets.request.item,
                        module: schedulerModules.request.item.product,
                        request_ref: schedulerRefs.request.item.product,
                        integration_id: integrationId,
                        destination_id: "",
                        action: 'create',
                        source_data: JSON.stringify(currentProduct)
                    }
                }

                console.log('dataSchedulerRequest', JSON.stringify(dataSchedulerRequest))

                // create scheduler request
                promises.push(
                    await createSchedulerRequest({
                        data: dataSchedulerRequest,
                        schedulerType: schedulerTypes.schedulerRequest,
                        targetType: schedulerTargetTypes.schedulerRequest
                    })
                )

            })

            let b = Promise.all(promises)
            // console.log('bbbb', b)

        }
    }

    // get product
    const getProduct = async ({ id, dataTypesArray = [`${getInjectionDataType('product')}`] }) => {

        const result = await get({ id, dataTypesArray })

        let data = result?.data ? result.data : {}

        return data

    }

    // create product item
    const addProductBatch = async ({ data }) => {

        let targetType = itemTargetTypes.product

        let result = await createBatch({ data, targetType })

        let response = result?.data?.products ? result.data.products : []

        return response
    }

    // done
    // split the product (from the container add item - split option)
    const splitProduct = async ({
        fromProduct: _fromProduct = {
            itemName: "",
            model: "",
            productCode: "",
            description: "",
            categoryId: "",
            brandId: "",
            summary: "",
            marking: "",
            userBranchId: "",
            userId: "",
            checkinDateTime: "",

            supplierName: "",
            supplierContact: "",
            courierTrackingNo: "",
            prepaidDepositAmount: "",
            prepaidTransportAmount: "",
            signUserId: "",
            signUserDisplay: "",
            remark: "",
            paymentType: "",
            purchaseNumber: "",
            supplierPurchaseNumber: "",
            barcode: "",
            locationId: "",
            locationDisplay: "",
            nfcPersonName: "",
            nfcIdentityNo: "",
            nfcFileId: "",
            nfcDetails: ""
        },
        fromProductItems: _fromProductItems = [
            {
                itemId: "",
                uomId: "",
                uomName: "",
                code: "",
                cost: 0,
                uomPrice: 0,
                floorPrice: 0,
                remark: "",
                grossWeight: 0,
                netWeight: 0,
                volumeWeight: 0,
                itemDescription: "",
                dimensionWidth: 0,
                dimensionHeight: 0,
                dimensionLength: 0,
                cbm: 0,
                scanningCodeSuffix: "",
                // status: 1,
                // is_package: 0,

                customUomName: "",

                handleQty: 0,
                handleQtyPerPackage: 0,
                loadQty: {
                    inputQty: 0,
                    maxQty: 0
                },
            }
        ],
        splitFromRemId,
        customSchedulerIntegrationId: _customSchedulerIntegrationId = ''
    }) => {

        let uniqueDateTime = dayjs().format("YYYYMMDDHHmmssSSS")

        let product = _fromProduct
        let items = _fromProductItems

        let dupProductId = ''
        let dupProductCode = ''
        let dupItemSuffixArray = []
        let result2 = []
        let result3 = []
        let dupItems = []

        let allInjectionFields = []

        // Step 1 - add bulk product
        if (product) {

            dupProductCode = `${product.productCode}-${getUniqueProductCodeShort()}`

            let data1 = {
                product: [
                    {
                        item_name: product.itemName,
                        model: product.model,
                        product_code: dupProductCode,
                        description: product.description,
                        category_id: product.categoryId,
                        brand_id: product.brandId,
                        summary: product.summary,
                        status: 1
                    }
                ]
            }

            let result1 = await addProductBatch({ data: data1 })

            // console.log('result1', result1)

            dupProductId = result1.length > 0 ? result1[0]?.id : ""
        }

        // Step 2 - add bulk items
        if (dupProductId !== '') {

            let data2 = items.map((i2, index2) => {

                // console.log('i2', i2)

                let useIndexNo = (index2 + 1)

                dupItemSuffixArray.push(
                    `${i2.scanningCodeSuffix}-${useIndexNo}`
                )

                // let dupItemCode = `${i2.code}-S${useIndexNo}`
                let dupItemCode = `${i2.code}-${uniqueDateTime}-S${useIndexNo}`

                return {

                    productId: dupProductId,
                    code: dupItemCode,
                    uomId: i2.uomId,
                    uomPrice: i2.uomPrice,
                    remark: i2.remark,
                    netWeight: i2.netWeight,
                    itemDescription: i2.itemDescription,
                    width: i2.dimensionWidth,
                    height: i2.dimensionHeight,
                    length: i2.dimensionLength,
                    cbm: i2.cbm,
                }
            })

            let payload = {
                data: data2,
                onlyCreateData: true // only create data
            }

            result2 = await addProductItemBatch(payload)
        }

        // Step 3 - add bulk props
        if (dupProductId !== '') {

            // dupItems = result2?.data?.items ? result2.data.items : []
            dupItems = result2

            // {
            //     item_id: 2562,
            //     scanning_code_prefix: ,
            //     scanning_code_suffix: -401-1
            // },

            let data3 = {
                item: dupItems.map((i3, index3) => {

                    // let itemCode = i3?.code
                    let itemId = i3?.id

                    let _suffixCode = dupItemSuffixArray[index3]

                    return {
                        item_id: itemId,
                        scanning_code_prefix: "",
                        scanning_code_suffix: _suffixCode
                    }
                })
            }

            // result3 = await createBatchPropsItems({ data: data3, targetType: itemTargetTypes.item })
            result3 = await addProductItemPropsBatch({ data: data3 })
            // console.log('result3', result3)
        }

        // console.log('dupProductId', dupProductId)

        // Step 4 - add bulk injection fields
        if (dupProductId !== "") {

            let mainData4 = {
                marking: product.marking,
                userBranchId: product.userBranchId,
                userId: product.userId
            }

            let _prepaidDepositAmount = product.prepaidDepositAmount
            let _prepaidTransportAmount = product.prepaidTransportAmount

            // force the deposit and transport to always reset during split
            _prepaidDepositAmount = 0.0000
            _prepaidTransportAmount = 0.0000

            let data4 = {
                input: {
                    supplierName: product.supplierName,
                    supplierContact: product.supplierContact,
                    courierTrackingNo: product.courierTrackingNo,
                    prepaidDepositAmount: _prepaidDepositAmount,
                    prepaidTransportAmount: _prepaidTransportAmount,
                    signUserId: product.signUserId,
                    signUserDisplay: product.signUserDisplay,
                    checkinDateTime: product.checkinDateTime,
                    remark: product.remark,
                    paymentType: product.paymentType,
                    purchaseNumber: product.purchaseNumber,
                    supplierPurchaseNumber: product.supplierPurchaseNumber,
                    appPrintPackQty: product?.appPrintPackQty,
                    isAppEntry: product?.isAppEntry,
                }
            }

            // append inj fields
            let injectFieldsDuplicateProduct = createProductInjectionFieldsPayload({
                productId: dupProductId,
                barcode: product.barcode,
                locationId: product.locationId,
                locationDisplay: product.locationDisplay,
                data: {
                    ...data4,
                    input: {
                        ...data4.input,
                        sourceProductRemId: 0
                    }
                },
                mainData: {
                    ...mainData4,
                    isSplit: 1,
                    splitFromRemId
                },
                nfcInfo: {
                    nfcPersonName: product.nfcPersonName,
                    nfcIdentityNo: product.nfcIdentityNo,
                    nfcFileId: product.nfcFileId,
                    nfcDetails: product.nfcDetails
                },
                skipTargetInjectionFieldIds: [
                    "sourceProductRemId",
                    "is_assigned_do",
                    "assigned_do_remid",
                    "assigned_do_number",
                    "lastUpdateDatetime",
                    "lastUpdateUserId",
                    "lastUpdateUserDisplay"
                ]
            })

            let injectionFieldsExistingProduct = []

            allInjectionFields = [...injectFieldsDuplicateProduct, ...injectionFieldsExistingProduct]

            dupItems = result2

            // console.log('items >>', items)

            items.forEach((i2, index2) => {

                let mainData5 = {
                    marking: product.marking,
                    userBranchId: product.userBranchId,
                    userId: product.userId
                }

                let currentItem = i2

                let customUomName = i2?.customUomName

                // console.log('cu', currentItem)

                let inputItemLoadQtyInput = parseFloat(currentItem?.loadQty?.inputQty)
                let inputItemLoadQtyMax = parseFloat(currentItem?.loadQty?.maxQty)

                let netWeight = parseFloat(currentItem?.netWeight)
                let cbm = parseFloat(currentItem?.cbm)
                let uomPrice = parseFloat(currentItem?.uomPrice)
                // Keep the decimals: rounding 222730.5 to 222730 here saved a value that no longer matched the item's qty x price.
                let handleQty = parseFloat(currentItem?.handleQty)
                let handleQtyPerPackage = parseInt(currentItem?.handleQtyPerPackage, 10)

                let existPackQty = inputItemLoadQtyInput
                let existTotalWeight = netWeight * parseFloat(existPackQty)
                existTotalWeight = existTotalWeight.toFixed(4)
                let existTotalCbm = cbm * parseFloat(existPackQty)
                existTotalCbm = existTotalCbm.toFixed(4)
                let existTotalValue = uomPrice * handleQty
                existTotalValue = existTotalValue.toFixed(2)

                // console.log('inputItemLoadQtyMax', inputItemLoadQtyMax, inputItemLoadQtyInput, existPackQty)

                let dupPackQty = inputItemLoadQtyMax - inputItemLoadQtyInput
                let dupTotalWeight = netWeight * parseFloat(dupPackQty)
                dupTotalWeight = dupTotalWeight.toFixed(4)
                let dupTotalCbm = cbm * parseFloat(dupPackQty)
                dupTotalCbm = dupTotalCbm.toFixed(4)
                let dupTotalValue = uomPrice * handleQty
                dupTotalValue = dupTotalValue.toFixed(2)

                let data5 = {
                    input: {
                        uomName: !customUomName ? currentItem?.uomName : customUomName,
                        qty: dupPackQty,
                        handleQty,
                        handleQtyPerPackage,
                        totalValue: dupTotalValue,
                        totalCbm: dupTotalCbm,
                        totalWeight: dupTotalWeight,
                    }
                }

                // append inj fields - for existing
                let injectFieldsProductItemExist = createProductItemInjectionFieldsPayload({
                    itemId: currentItem?.itemId,
                    data: {
                        ...data5,
                        input: {
                            ...data5.input,
                            qty: existPackQty,
                            totalValue: existTotalValue,
                            totalCbm: existTotalCbm,
                            totalWeight: existTotalWeight,
                        }
                    },
                    mainData: mainData5,
                    targetInjectionFieldIds: [
                        `packQty`,
                        `totalValue`,
                        `totalCbm`,
                        `totalWeight`,
                    ]
                })

                console.log('injectFieldsProductItemExist >> ', injectFieldsProductItemExist)

                // append inj fields - new dup
                let injectFieldsProductItemNew = createProductItemInjectionFieldsPayload({
                    itemId: dupItems[index2]?.id,
                    data: {
                        ...data5,
                        input: {
                            ...data5.input,
                            sourceItemRemId: 0
                        }
                    },
                    mainData: mainData5,
                    skipTargetInjectionFieldIds: ["sourceItemRemId"]
                })

                allInjectionFields = [...allInjectionFields, ...injectFieldsProductItemNew, ...injectFieldsProductItemExist]

            })

        }

        // injection fields
        if (allInjectionFields.length > 0) {

            let dataInjectionProps = getUpdateFieldValuesPayload({ items: allInjectionFields })

            await updateFieldValues({ data: dataInjectionProps, overrideScopeType: injectionFieldScopeTypes.item.id })

        }

        // console.log('schedulerConfigs?.schedulerIntegrationIds', schedulerConfigs?.schedulerIntegrationIds)

        if (
            (schedulerConfigs?.schedulerIntegrationIds &&
                schedulerConfigs?.schedulerIntegrationIds.length > 0) ||
            _customSchedulerIntegrationId !== ''
        ) {


            let integrationId = schedulerConfigs?.schedulerIntegrationIds[0]

            if (_customSchedulerIntegrationId) {
                integrationId = _customSchedulerIntegrationId
            }

            let currentProduct = await fetchProduct({ productId: dupProductId })

            // let currentProductSourceProductRemId = currentProduct[productInjectionProps]

            // console.log('currentProduct', currentProduct)

            let dataSchedulerRequest = {
                scheduler_request: {
                    source_id: dupProductId,
                    target: schedulerTargets.request.item,
                    module: schedulerModules.request.item.product,
                    request_ref: schedulerRefs.request.item.product,
                    integration_id: integrationId,
                    destination_id: "",
                    action: 'create',
                    source_data: JSON.stringify(currentProduct)
                }
            }

            // console.log('dataSchedulerRequest', JSON.stringify(dataSchedulerRequest))

            // create scheduler request
            await createSchedulerRequest({
                data: dataSchedulerRequest,
                schedulerType: schedulerTypes.schedulerRequest,
                targetType: schedulerTargetTypes.schedulerRequest
            })
        }

    }

    // done
    // update the product remark only
    const updateProductRemark = async ({
        productId: _productId = '',
        remark: _remark = '',
    }) => {

        // let injectionPropsProduct = []
        let injectionFieldsProduct = []

        // change inj props - for existing product remark only
        // let a = createProductInjectionPropsPayload({
        //     productId: _productId,
        //     barcode: ``,
        //     data: {
        //         input: {
        //             remark: `${_remark}`
        //         }
        //     },
        //     mainData: {},
        //     targetInjectionPropIds: [
        //         `remark`
        //     ]
        // })

        // change inj fields - for existing product remark only
        let b = createProductInjectionFieldsPayload({
            productId: _productId,
            barcode: ``,
            data: {
                input: {
                    remark: `${_remark}`
                }
            },
            mainData: {},
            targetInjectionFieldIds: [
                `remark`
            ]
        })

        // injectionPropsProduct = [...injectionPropsProduct, ...a]
        injectionFieldsProduct = [...injectionFieldsProduct, ...b]

        if (injectionFieldsProduct.length > 0) {

            // create injection fields
            const responseProductInjectionFields = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFieldsProduct }) })

            console.log('responseProductInjectionFields', responseProductInjectionFields)

        }

        console.log('schedulerConfigs?.schedulerIntegrationIds', schedulerConfigs?.schedulerIntegrationIds)

        if (
            schedulerConfigs?.schedulerIntegrationIds &&
            schedulerConfigs?.schedulerIntegrationIds.length > 0
        ) {

            let dataTypesArray = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

            const currentProduct = await getProduct({ id: _productId, dataTypesArray })

            // let currentProduct = await fetchProduct({ productId })

            // let currentProductSourceProductRemId = currentProduct[productInjectionProps]

            // console.log('currentProduct', currentProduct)

            let dataSchedulerRequest = {
                scheduler_request: {
                    source_id: _productId,
                    target: schedulerTargets.request.item,
                    module: schedulerModules.request.item.product,
                    request_ref: schedulerRefs.request.item.product,
                    integration_id: schedulerConfigs?.schedulerIntegrationIds[0],
                    destination_id: currentProduct[productInjectionProps.sourceProductRemId.retrieveKey],
                    action: 'update',
                    source_data: JSON.stringify(currentProduct)
                }
            }

            // console.log('dataSchedulerRequest', JSON.stringify(dataSchedulerRequest))

            // create scheduler request
            await createSchedulerRequest({ data: dataSchedulerRequest, schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })
        }

    }

    // done
    // update the product load container datetime only
    const updateProductLoadContainerDateTime = async ({
        productId: _productId = '',
        sourceProductRemId: _sourceProductRemId = '',
        sourceContainerRemId: _sourceContainerRemId = '',
        loadContainerDateTime: _loadContainerDateTime = '',
    }) => {

        let injectionFieldsProduct = []

        // change inj fields - for existing product load container date time only
        let b = createProductInjectionFieldsPayload({
            productId: _productId,
            barcode: ``,
            data: {},
            mainData: {},
            loadContainerDateTime: _loadContainerDateTime,
            targetInjectionFieldIds: [
                `loadContainerDateTime`
            ]
        })

        injectionFieldsProduct = [...injectionFieldsProduct, ...b]

        if (injectionFieldsProduct.length > 0) {

            // create injection fields
            const responseProductInjectionFields = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFieldsProduct }) })

            console.log('responseProductInjectionFields', responseProductInjectionFields)

        }

        console.log('schedulerConfigs?.schedulerIntegrationIds', schedulerConfigs?.schedulerIntegrationIds)

        if (
            schedulerConfigs?.schedulerIntegrationIds &&
            schedulerConfigs?.schedulerIntegrationIds.length > 0
        ) {

            let dataTypesArray = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

            const currentProduct = await getProduct({ id: _productId, dataTypesArray })

            // let currentProduct = await fetchProduct({ productId })

            // let currentProductSourceProductRemId = currentProduct[productInjectionProps]

            // console.log('currentProduct', currentProduct)

            let dataSchedulerRequest = {
                scheduler_request: {
                    source_id: _productId,
                    target: schedulerTargets.request.item,
                    module: schedulerModules.request.item.product,
                    request_ref: schedulerRefs.request.item.product,
                    integration_id: schedulerConfigs?.schedulerIntegrationIds[0],
                    destination_id: currentProduct[productInjectionProps.sourceProductRemId.retrieveKey],
                    action: 'update',
                    // source_data: JSON.stringify(currentProduct)
                    source_data:
                        JSON.stringify({
                            ...currentProduct,
                            modifySourceProductRemId: _sourceProductRemId,
                            modifySourceContainerRemId: _sourceContainerRemId,
                            modifyLoadContainerDateTime: _loadContainerDateTime,
                            updateType: "modifyLoadContainerDateTime",
                            // haveSplit: Boolean(_needToSplit)
                        })
                }
            }

            // console.log('dataSchedulerRequest', JSON.stringify(dataSchedulerRequest))

            // create scheduler request
            await createSchedulerRequest({ data: dataSchedulerRequest, schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })
        }

    }

    const deleteProducts = async ({
        selectedData: _selectedData = [],
        selectedIds: _selectedIds = []
    }) => {

        let filterSelectedData = []

        _selectedData.forEach(i => {
            if (i) {
                filterSelectedData.push(i)
            }
        })

        // console.log('filterSelectedData', filterSelectedData)

        const selectedIsLoaded = filterSelectedData.filter(i => i[productInjectionProps.loadStatus.retrieveKey] === productLoadStatusTypes.loaded.id)

        if (selectedIsLoaded.length > 0) {
            // promptMessage(false, `Failed to remove due to selected ${isLoaded.length} products already loaded to containers`)
            // setSystemLoading(false)
            // promptMessage(false, t("failedToRemoveProductsDueToLoadedContainer", { no: selectedIsLoaded.length }))
            // return false
            throw Error("failedToRemoveProductsDueToLoadedContainer")
        }

        // const result = await remove({ ids: selectedIds })
        await remove({ ids: _selectedIds })
    }

    // change owner for products
    const changeProductsOwner = async ({
        // productIds = [],
        products = [{
            productId: "",
            fromMarking: "",
            fromMarkingId: "",
            fromMarkingUserId: "",
            sourceProductRemId: ""
        }],
        toMarkingId,
        toMarkingUserId,
        toMarking,
        toSourceMarkingRemId,
        actionUserId
    }) => {

        let dataInjectionFields = []

        // insert injection fields
        products.forEach(i => {

            let productId = i?.productId

            // append inj fields
            let iF = createProductInjectionFieldsPayload({
                productId,
                mainData: {
                    marking: toMarking,
                    userBranchId: toMarkingId,
                    userId: toMarkingUserId
                },
                targetInjectionFieldIds: [
                    "customerMarking",
                    "customerBranchId",
                    "customerUserId",
                ],
            })

            // console.log('iF', iF)

            dataInjectionFields = [...dataInjectionFields, ...iF]

        })

        // console.log('dataInjectionFields', dataInjectionFields)

        // create injection fields
        const responseProductInjectionFields = await updateFieldValues({
            data: getUpdateFieldValuesPayload({ items: dataInjectionFields }),
            overrideScopeType: injectionFieldScopeTypes.item.id,
        })

        // const responseInjectionFields = await updateFieldValues({ data: dataInjectionFields });

        // console.log('responseProductInjectionFields', responseProductInjectionFields)
        if (
            schedulerConfigs?.schedulerIntegrationIds &&
            schedulerConfigs?.schedulerIntegrationIds.length > 0
        ) {

            let integrationId = schedulerConfigs?.schedulerIntegrationIds[0]

            // if (_customSchedulerIntegrationId) {
            //     integrationId = _customSchedulerIntegrationId
            // }

            await Promise.all(products.map(async (i) => {

                let productId = i?.productId
                let fromMarking = i?.fromMarking
                let fromMarkingId = i?.fromMarkingId
                let fromMarkingUserId = i?.fromMarkingUserId
                let sourceProductRemId = i?.sourceProductRemId

                let dataSchedulerRequest = {
                    scheduler_request: {
                        source_id: productId,
                        target: schedulerTargets.request.item,
                        module: schedulerModules.request.item.product,
                        request_ref: schedulerRefs.request.item.product,
                        integration_id: integrationId,
                        destination_id: sourceProductRemId,
                        action: 'update',
                        source_data:
                            JSON.stringify({
                                // ...currentProduct,
                                sourceProductRemId,
                                fromMarking,
                                fromMarkingId,
                                fromMarkingUserId,
                                toMarking,
                                toMarkingId,
                                toMarkingUserId,
                                toSourceMarkingRemId,
                                actionUserId,
                                updateType: "changeOwner"
                            })
                    }
                }

                console.log('create load update product change marking : ', JSON.stringify(dataSchedulerRequest))

                // create scheduler request
                await createSchedulerRequest({ data: dataSchedulerRequest, schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })

            }))

        }

        return responseProductInjectionFields

    }

    const sortProductsByGroupMarking = ({ products }) => {

        let _finalProducts = []
        let _skipIds = []
        let _relatedItems = []

        products.forEach(i => {
            let _id = i?.id
            let _marking = i[productInjectionFields.customerMarking.retrieveKey]

            if (_skipIds.includes(_id) === false) {

                // search the rest of the array have this marking or not
                let _search = products.filter(i2 => i2.id !== _id && i2[productInjectionFields.customerMarking.retrieveKey] === _marking)

                if (_search.length <= 0) { // not found
                    _finalProducts = [..._finalProducts, i]

                } else { // have other in sequences

                    _finalProducts = [..._finalProducts, i]

                    _search.forEach(i3 => {
                        _finalProducts = [..._finalProducts, i3]
                        _skipIds.push(i3?.id)
                    })
                }

                // _sequences.push(_marking)

            }

            // console.log('i.items', i)

            _relatedItems = [..._relatedItems, ...i.items]

        })

        return {
            finalProducts: _finalProducts,
            relatedItems: _relatedItems,
            skipIds: _skipIds
        }

    }

    // for modifying just the last update action - product
    const updateLastUpdateProduct = async ({
        productId,
        lastUpdateDatetime = dayjs().format("YYYY-MM-DD HH:mm:ss"),
        lastUpdateUserId,
        lastUpdateUserDisplay
    }) => {

        // update the injection fields
        let b = createProductInjectionFieldsPayload({
            productId,
            mainData: {
                lastUpdateDatetime,
                lastUpdateUserId,
                lastUpdateUserDisplay,
            },
            targetInjectionFieldIds: [
                `lastUpdateDatetime`,
                `lastUpdateUserId`,
                `lastUpdateUserDisplay`,
            ]
        })

        // console.log('dataInjectionFields', b)

        const response = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: b }), overrideScopeType: injectionFieldScopeTypes.item.id });

        // console.log('res', response)

        return response

    }

    // resync product for create - recreate the request for create product for sync
    const resyncProduct = async ({ productId, customSchedulerIntegrationId: _customSchedulerIntegrationId = '' }) => {

        productId = `${productId}`

        let currentProduct = await getProduct({ id: productId, dataTypesArray: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`] })
        // console.log('currentProduct', currentProduct)

        // check current any scheduler request found
        const props = {
            limit: 1,
            skip: 0,
            filterValue: [
                {
                    name: `source_id`,
                    operator: filterOperatorTypes.eq,
                    value: productId
                },
                {
                    name: `target`,
                    operator: filterOperatorTypes.eq,
                    value: `item`
                },
                {
                    name: `module`,
                    operator: filterOperatorTypes.eq,
                    value: `product`
                }
            ],
            sortInfo: {
                id: 'source_id',
                dir: -1
            }
        }

        const { data: dataSchedulerRequest } = await listSchedulerRequest(props)

        const latestRequests = dataSchedulerRequest?.scheduler_requests ? dataSchedulerRequest.scheduler_requests : []
        const latestRequest = latestRequests.length > 0 ? latestRequests[0] : {}
        const latestRequestCreatedDatetime = latestRequest?.ax_createdatetime ? dayjs(latestRequest.ax_createdatetime) : dayjs()

        // console.log('dataSchedulerRequest', dataSchedulerRequest)
        // console.log('latestRequest', latestRequest)
        // console.log('latestRequestCreatedDatetime', latestRequestCreatedDatetime)

        if (latestRequest?.id) { // only if found only check this

            const now = dayjs();

            const isSameMonthAndYear = (
                latestRequestCreatedDatetime.year() === now.year() && latestRequestCreatedDatetime.month() === now.month()
            );

            // console.log('latestRequestCreatedDatetime.year()', latestRequestCreatedDatetime.year(), latestRequestCreatedDatetime.month())
            // console.log('now.year()', now.year(), now.month())

            // console.log('isSameMonthAndYear', JSON.stringify(isSameMonthAndYear))

            if (isSameMonthAndYear) {
                throw Error(`The existing request created at ${latestRequestCreatedDatetime.format("YYYY-MM-DD HH:mm:ss")} [${latestRequest?.id}]`)
            }

        }


        let integrationId = ''

        // add the scheduler requests
        // console.log('schedulerConfigs?.schedulerIntegrationIds', schedulerConfigs?.schedulerIntegrationIds)
        if (
            (schedulerConfigs?.schedulerIntegrationIds &&
                schedulerConfigs?.schedulerIntegrationIds.length > 0) ||
            _customSchedulerIntegrationId !== ''
        ) {

            integrationId = schedulerConfigs?.schedulerIntegrationIds[0]

            if (_customSchedulerIntegrationId) {
                integrationId = _customSchedulerIntegrationId
            }

        }

        console.log('integrationId', integrationId)

        if (!integrationId) {

            throw Error(`Invalid integration Id`)

        } else {

            let dataSchedulerRequest = {
                scheduler_request: {
                    source_id: productId,
                    target: schedulerTargets.request.item,
                    module: schedulerModules.request.item.product,
                    request_ref: schedulerRefs.request.item.product,
                    integration_id: integrationId,
                    destination_id: "",
                    action: 'create',
                    source_data: JSON.stringify(currentProduct)
                }
            }

            console.log('dataSchedulerRequest', JSON.stringify(dataSchedulerRequest))

            let response = await createSchedulerRequest({
                data: dataSchedulerRequest,
                schedulerType: schedulerTypes.schedulerRequest,
                targetType: schedulerTargetTypes.schedulerRequest
            })

            return response
        }

    }

    return {
        filterOperatorTypes,
        checkProductIsLoadedContainer,
        listProducts,
        addProduct,
        getProduct,
        updateProduct,
        addProductBatch,
        splitProduct,
        updateProductRemark,
        updateProductLoadContainerDateTime,
        deleteProducts,
        changeProductsOwner,
        sortProductsByGroupMarking,
        updateLastUpdateProduct,
        resyncProduct
    }
}